<template>
  <div class="ticket-index">
    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Pesquisar por Placa"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>

      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgeFilters"
        />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-3">
          <label>Contas</label>
          <Select2 :options="filterAccount" v-model="query.accountId" title-load="Carregando contas..."/>
        </div>

        <div class="col-md-3">
          <label>Órgão consultado</label>
          <Select2 :options="filterConsultedAuthority" v-model="query.consultedAuthorities"/>
        </div>

        <div class="col-md-3">
          <label>Órgão autuador</label>
          <Select2 :options="filterIssuingAuthority" v-model="query.issuingAuthority"/>
        </div>

        <div class="col-md-3">
          <label>Status</label>
          <Select2 :options="filterStatus" v-model="query.status"/>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-3">
          <label>Status do boleto</label>
          <Select2 :options="filterBoletoStatus" v-model="query.boletoStatus"/>
        </div>

        <div class="col-md-3">
          <label for="type-period">Tipo do período</label>
          <select v-model="query.periodType" id="type-period" class="browser-default custom-select">
            <option value="updated_at">Data de atualização</option>
            <option value="created_at">Data de criação</option>
            <option value="expired_at">Data de vencimento</option>
            <option value="occurred_at">Data da infração</option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-3">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr>

    <!-- Buttons -->
    <div class="row mt-2">
      <div class="col-md-12">
        <button
          class="btn btn-primary mt-1 mr-1"
          @click="reprocess"
          :disabled="disabledReprocess"
        >
          Gerar consultas
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col-sm-12">

        <div class="row mt-4">
          <div class="col-md-12">
            <strong class="mr-3">
              {{infoTotalModels}}
            </strong>

            <button
              class="btn btn-outline ml-3 mb-1"
              v-if="tickets.length > 0"
              @click="changeCheckAll"
              :class="{ 'btn-outline-active': checkAll}"
            >
              {{ !checkAll ? 'Selecionar todas' : 'Desmarcar todas' }} ({{ meta.totalCount || 'Calculando' }})
            </button>

            <div class="float-right" style="display: inline-flex;align-items: center;">
              <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
              <select v-model="order" @change="find()" class="browser-default custom-select">
                <option :value="['updated_at', 'desc']">Data de atualização</option>
                <option :value="['created_at', 'desc']">Data de criação</option>
              </select>
            </div>
          </div>
        </div>

        <table class="table table-borderless table-align table-h51">
          <thead>
            <tr>
              <th>
                <BkpsCheckBox :value="checkAllRow" @input="changeCheckAllRow"/>
              </th>
              <th>ID</th>
              <th>Conta</th>
              <th>AIT</th>
              <th>Placa</th>
              <th>Renavam</th>
              <th>Status</th>
              <th>Órgão consultado</th>
              <th>Órgão autuador</th>
              <th>Ocorrido em</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ticket in tickets" :key="ticket.id">
              <td>
                <BkpsCheckBox v-model="ticket.checked" @input="changeCheckRow"/>
              </td>
              <td>{{ ticket.id }}</td>
              <td>{{ getAccountName(ticket) }}</td>
              <td>{{ ticket.ait }}</td>
              <td>{{ ticket.plate }}</td>
              <td>{{ ticket.renavam }}</td>
              <td>{{ ticket.status | t }}</td>
              <td>{{ ticket.consultedAuthorities | consultedAuthorities }}</td>
              <td>{{ ticket.issuingAuthority | issuingAuthority }}</td>
              <td>{{ ticket.occurredAt | date }}</td>
              <td>{{ ticket.createdAt | datetime }}</td>
              <td>{{ ticket.updatedAt | datetime }}</td>
              <td>
                <router-link :to="`/admin/maestro/tickets/${ticket.id}`" class="btn btn-outline">
                  Ver
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
  import CheckedModels from '@/mixins/CheckedModels'
  import GlobalLoading from '@/mixins/GlobalLoading'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import ModelMapper from '@/mixins/ModelMapper'
  import Select2 from '@/components/shares/Select2'

  import { IssuingAuthority } from '@/models/IssuingAuthority'
  import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
  import { Filter } from '@/models/filter'
  import qs from 'qs'

  const MAX_QUERY_LENGTH = 1800

  // Helper function to get unique tickets by plate
  const getUniqueTicketsByPlate = (tickets) => {
    // Use reduce to create a map of plates to tickets more efficiently
    const plateMap = tickets.reduce((map, ticket) => {
      if (!map.has(ticket.plate)) {
        map.set(ticket.plate, ticket)
      }
      return map
    }, new Map())

    return Array.from(plateMap.values())
  }

  // Helper function to handle error messages
  const handleErrorMessage = (error, ticket, instance) => {
    // Define error message patterns and their corresponding formatted messages
    const errorPatterns = [
      {
        pattern: 'Boleto já está disponível',
        message: `Boleto já está disponível para a placa ${ticket.plate}`
      },
      {
        pattern: 'Boleto não está disponível no site de origem',
        message: `Boleto não está disponível no site de origem para a placa ${ticket.plate}`
      },
      {
        pattern: 'Já existe uma consulta em processamento para este veículo',
        message: `Já existe uma consulta em processamento para a placa ${ticket.plate}`
      }
    ]

    // Check if error matches any pattern
    for (const { pattern, message } of errorPatterns) {
      if (error.includes(pattern)) {
        instance.$notify.addError({ errors: message })
        return
      }
    }

    // Special case for ScrapingService
    if (error.includes('ScrapingService') && error.includes('está desativado')) {
      instance.$notify.addError({ errors: `${error} para a placa ${ticket.plate}` })
      return
    }

    // Default case
    instance.$notify.addError({ errors: error })
  }

  const reprocess = (tickets, instance) => {
    let delay = 0
    tickets = tickets.filter(t => t.checked)

    // Get unique tickets by plate
    const uniqueTickets = getUniqueTicketsByPlate(tickets)

    instance.openLoad()
    uniqueTickets.forEach(ticket => {
      setTimeout(() => reprocessTicket(ticket, instance), delay)
      delay += 500
    })

    setTimeout(() => {
      instance.closeLoad()
      instance.asyncTemplateSelect({
        pagination: true
      })
    }, delay)
  }

  const reprocessTicket = (ticket, instance) => {
    instance.axios.put(`admin/maestro/tickets/${ticket.id}/reprocess`)
      .then(() => instance.$notify.add(`Consulta gerada para a placa ${ticket.plate}`))
      .catch(e => {
        // Handle specific error messages from backend
        if (e.errors && typeof e.errors === 'object' && Array.isArray(e.errors)) {
          e.errors.forEach(error => handleErrorMessage(error, ticket, instance))
        } else {
          instance.$notify.addError(e)
        }
      })
  }

  const batchReprocess = (query, instance) => {
    instance.openLoad()
    instance.axios.post('admin/maestro/tickets/batch_reprocess', query)
      .then(response => {
        if (response.success_count && response.error_count) {
          instance.$notify.add(`${response.success_count} consulta(s) gerada(s) com sucesso. ${response.error_count} falha(s).`)

          // If there are specific error messages in the response, display them
          if (response.errors && Array.isArray(response.errors)) {
            // Create a dummy ticket object for error handling
            const dummyTicket = { plate: 'selecionada' }
            response.errors.forEach(error => handleErrorMessage(error, dummyTicket, instance))
          }
        } else {
          instance.$notify.add('Consulta(s) gerada(s) com sucesso')
        }
      })
      .catch(e => {
        // Handle specific error messages from backend
        if (e.errors && typeof e.errors === 'object' && Array.isArray(e.errors)) {
          // Create a dummy ticket object for error handling
          const dummyTicket = { plate: 'selecionada' }
          e.errors.forEach(error => handleErrorMessage(error, dummyTicket, instance))
        } else {
          instance.$notify.addError(e)
        }
      })
      .finally(() => {
        instance.checkAll = false
        instance.checkAllRow = false
        instance.tickets.forEach(t => t.checked = false)
        instance.closeLoad()
      })
  }

  export default {
    components: { BadgeFilters, BkpsCheckBox, ChevronDownIcon, Pagination, SearchIcon, Select2 },
    computed: {
      badgeFilters() {
        return [
          this.filterAccount, this.filterEndDate, this.filterStatus,
          this.filterStartDate, this.filterConsultedAuthority,
          this.filterIssuingAuthority, this.filterBoletoStatus
        ]
      },
      disabledReprocess() {
        return !this.tickets.some(t => t.checked)
      },
      selectedTickets() {
        return this.tickets.filter(t => t.checked)
      },
      tickets() {
        return this.getModels || []
      },

    },
    created() {
      this.addOrderBy('updatedAt')
      this.$set(this.query, 'periodType', 'updated_at')

      const date = new Date()
      date.setHours(0, 0, 0)
      this.$set(this.query, 'startDate', date.toISOString().substring(0, 10))

      this.defaultModelSetting.updateQueryURL = true
      this.asyncTemplateSelect({
        byURL: true,
        pagination: true
      })

      this.filterAccount = this.buildFilterAccount(this.allAccounts.data)

      this.loadFilters()
    },
    data: () => ({
      accounts: [],
      filterAccount: null,
      filterEndDate: new Filter({
        key: 'endDate',
        label: 'Data final',
        type: 'date'
      }),
      filterStartDate: new Filter({
        key: 'startDate',
        label: 'Data inicial',
        type: 'date'
      }),
      filterStatus: new Filter({
        key: 'status',
        label: 'Status',
        table: [
          ['cancelado', 'canceled'],
          ['vencido', 'expired'],
          ['pago', 'paid'],
          ['prescrito', 'prescribed'],
          ['em aberto', 'opened'],
          ['sem informação', 'undefined']
        ]
      }),
      filterBoletoStatus: new Filter({
        key: 'boletoStatus',
        label: 'Status do boleto',
        table: [
          ['sem boleto', 'not_available'],
          ['disponível', 'available'],
          ['processando', 'processing'],
        ]
      }),
      filterConsultedAuthority: new Filter({
        key: 'consultedAuthorities',
        label: 'Órgão consultado',
        table: IssuingAuthority.table().concat([['SNE', 'SNE']])
      }),
      filterIssuingAuthority: null,
      nameModel: 'Ticket',
      showModal: false,
    }),
    filters: {
      consultedAuthorities(authorities) {
        return authorities.map(code => IssuingAuthority.label(code)).join(' + ')
      },
      issuingAuthority(code) {
        return IssuingAuthority.label(code)
      }
    },
    inject: ['allAccounts', 'buildFilterAccount', 'getAccountName'],
    methods: {
      async asyncSelect(path, params, headers) {
        this.previousQuery = this.$parse.clone(this.query)

        const body = qs.stringify(params, { arrayFormat: 'brackets', encode: false })

        if (body.length <= MAX_QUERY_LENGTH)
          return this.axios.get(path, { headers, params })

        return this.axios.post(`${path}/search`, body, {
          headers: { ...headers, 'Content-Type': 'application/x-www-form-urlencoded' }
        })
      },
      updateQueryURL(params) {
        if (!this.defaultModelSetting.updateQueryURL)
          return

        const body = qs.stringify(params, { arrayFormat: 'brackets', encode: false })
        if (body.length <= MAX_QUERY_LENGTH)
          this.$utilUri.updateQuery(params)
      },
      async loadFilters() {
        await this.loadIssuingAuthorities()
      },
      loadIssuingAuthorities() {
        return this.axios.get('/maestro/tickets/fetch_column/issuing_authority')
          .then(response => {
            this.filterIssuingAuthority = new Filter({
              key: 'issuingAuthority',
              label: 'Órgão autuador',
              table: response.data.map(code => [IssuingAuthority.label(code), code])
            })
          })
      },
      buildPath() {
        return 'admin/maestro/tickets'
      },
      changeCheckAllRow(value) {
        this.changeCheck({ checkAllRow: value, sources: this.tickets })
      },
      changeCheckAll() {
        this.changeCheck({ checkAll: !this.checkAll, sources: this.tickets })
      },
      changeCheckRow() {
        this.changeCheck({ sources: this.tickets })
      },
      find() {
        this.asyncTemplateSelect()
      },
      issuingAuthority(code) {
        return IssuingAuthority.label(code)
      },
      reprocess() {
        // Get distinct plates using Set to remove duplicates
        const distinctPlatesArray = this.checkAll
          ? ['todas as placas selecionadas']
          : [...new Set(this.tickets.filter(t => t.checked).map(t => t.plate))]

        const distinctPlatesText = distinctPlatesArray.join(', ')

        if (!confirm(`Gerar consultas para ${distinctPlatesText}.\n\nAtenção: Será gerada apenas uma consulta por placa, independentemente do número de multas selecionadas.\nSe já existir uma consulta em processamento para a mesma placa, o reprocessamento não será realizado.\n\nDeseja continuar?`))
          return

        if (this.checkAll)
          batchReprocess(this.buildParams(), this)
        else
          reprocess(this.tickets, this)
      },
    },
    mixins: [ModelMapper, CheckedModels, GlobalLoading],
    name: 'Index',
    watch: {
      allAccounts: {
        deep: true,
        handler(value) {
          this.filterAccount = this.buildFilterAccount(value.data)
        },
      },
      allUsers: {
        deep: true,
        handler(value) {
          this.filterEmail = this.buildFilterEmail(value.data)
        },
      },
      tickets(newValue, oldValue) {
        if (newValue !== oldValue)
          this.changeCheck({checkAllRow: false})
      }
    }
  }
</script>

<style scoped>
  .fa-angle-right {
    transition: transform .2s;
    margin-left: 8px;
  }
</style>
